import {

    RESET_MESSAGE,
    GET_DELIVERY_CHALLAN_CUSTOMER_LIST_SUCCESS,
    GET_DELIVERY_CHALLAN_CUSTOMER_LIST_FAILURE,
    GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS,
    ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    ADD_DELIVERY_CHALLAN_CUSTOMER_SUCCESS,
    ADD_DELIVERY_CHALLAN_CUSTOMER_FAILURE,
    EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS,
    EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_SUCCESS,
    EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_FAILURE,

} from '../../types/actionTypes';

const initialState = {
    delivery_challan_customer: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const delivery_challan_customer_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_DELIVERY_CHALLAN_CUSTOMER_LIST_SUCCESS:
            return { ...state, delivery_challan_customer: action.delivery_challan_customer, loading: false };
        case GET_DELIVERY_CHALLAN_CUSTOMER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DELIVERY_CHALLAN_CUSTOMER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_DELIVERY_CHALLAN_CUSTOMER_PROGRESS:
            return { ...state, loading: true };
        case ADD_DELIVERY_CHALLAN_CUSTOMER_SUCCESS:
            return { ...state, delivery_challan_customer: [...state.delivery_challan_customer, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_DELIVERY_CHALLAN_CUSTOMER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_SUCCESS:
            return {
                ...state,
                delivery_challan_customer: state.delivery_challan_customer.map((delivery_challan_customer) =>
                    delivery_challan_customer.id === action.payload.id ? action.payload : delivery_challan_customer
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_DELIVERY_CHALLAN_CUSTOMER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default delivery_challan_customer_reducer;